{
  "title": "新手上路：評審第一次使用指南",
  "description": "從收到評審邀請到送出第一筆評分，快速了解評審在 NAPAICP 上完整的第一次使用流程。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "讀完後，您會知道如何接受評審邀請並登入、申報利益衝突、查看指派給您的匿名化作品清單，以及如何完成並鎖定一筆評分。",
  "roleNote": "評審",
  "prerequisites": ["已收到主辦方寄送的評審邀請信"],
  "pathLabel": "登入頁",
  "steps": [
    {
      "title": "1. 收到評審邀請",
      "description": "主辦方以 Email 寄送評審邀請。若您是新帳號，信件會附上一組僅供本人使用的臨時初始密碼，有效期 48 小時；若您原本就有平台帳號，信件只會請您登入並在「總覽」頁回覆邀請，不會附上任何密碼。"
    },
    {
      "title": "2. 登入，新帳號需先完成強制設定新密碼",
      "description": "已有帳號者以既有帳號密碼登入，並在「總覽」頁的「待回覆的評審邀請」按「接受邀請」（或「婉拒」），接受後才會取得評審身分。新帳號請使用信件中的帳號與臨時密碼登入；登入成功後畫面會直接顯示「請設定您的新密碼」畫面，取代平台其餘內容，輸入新密碼並送出即完成，完成前無法存取任何評審或競賽保護資料，送出成功後系統會自動載入正常畫面。"
    },
    {
      "title": "3. 進入評審工作區查看指派清單",
      "description": "指派清單只顯示指派給您的作品（已申報迴避的作品仍會列出，並標示「已申報迴避」徽章），一律以匿名代碼呈現，看不到參賽者真實身分，也看不到其他評審的指派內容；每筆會顯示狀態徽章（未開始／草稿／已送出）。"
    },
    {
      "title": "4. 視需要自行申報利益迴避",
      "description": "若您與某件作品的參賽者有可能影響評分公正性的關係（例如指導過該隊伍、有親屬或雇用關係），在指派清單該筆作品旁點選「申報利益衝突」並填寫理由；申報成功後該作品仍會留在清單中，但會加上「已申報迴避」徽章、無法再進入評分頁，不會因重新整理或重新登入而恢復。"
    },
    {
      "title": "5. 依評分規準完成並送出第一筆評分",
      "description": "依每個評分項目的允許範圍與說明評分；「審查意見」欄位是主辦方看得到的評論，「個人評審備註」則僅供您本人參考，絕不會顯示給主辦方。所有評分項目都填寫完成前，「正式送出」按鈕會維持disabled狀態；若該場競賽另外開啟「審查意見必填」設定，未填寫審查意見同樣無法送出。"
    },
    {
      "title": "6. 認識「送出即鎖定」",
      "description": "點擊「正式送出評分」的當下，分數會立即從草稿直接變成鎖定狀態，沒有中間的「已送出但尚未鎖定」過渡狀態；送出後您本人無法自行修改，需請具權限的主辦方在該作品的投稿詳情頁點擊「重新開放」並填寫理由，您才能再次編輯。"
    }
  ],
  "afterward": [
    "登入後可在評審工作區隨時查看目前指派件數與完成進度",
    "已申報利益迴避的作品會持續標示「已申報迴避」徽章且無法評分，不會因重新整理或重新登入而恢復",
    "已送出並鎖定的分數會切換為唯讀覆核模式，可查看總分與各項目加權後的貢獻"
  ],
  "nextSteps": "完整規則、評分表兩個評語欄位的差異，以及利益衝突判定原則，請見「操作手冊：評審」。",
  "faq": [
    {
      "q": "臨時密碼收不到或過期了怎麼辦？",
      "a": "臨時初始密碼只在產生後的單次通知信中出現，有效期 48 小時，資料庫僅保存雜湊值無法查詢；可在登入頁使用「忘記密碼」，以受邀 Email 收取重設連結並設定新密碼後直接登入；也可請主辦方在「評審邀請與指派」頁點選「重新發送」，會產生新密碼並讓舊密碼立即失效。"
    },
    {
      "q": "指派清單裡看得到參賽者的真實姓名或學校嗎？",
      "a": "看不到。指派清單一律以匿名代碼呈現作品，評審端本來就不會回傳不應揭露的參賽者身分資訊；系統也不會、也不應該讓評審自行把匿名代碼與真實身分對照。"
    },
    {
      "q": "送出評分後才發現分數打錯，能自己改嗎？",
      "a": "不能。分數送出即鎖定，評審本人無法自行修改；請聯絡主辦方，具權限的主辦方可以在該作品的投稿詳情頁點擊「重新開放」並填寫理由後，讓您重新編輯並再次送出。"
    }
  ]
}
